"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Point = _interopRequireDefault(require("./Point"));
var _CoordinateBounds = _interopRequireDefault(require("../../geo/CoordinateBounds"));
var _utils = require("../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class MultiPoint {
  constructor(coords) {
    if ((0, _utils.isEmpty)(coords)) {
      throw new Error('Invalid coordinates for MultiPoint');
    }
    this.points = coords.map(pointCoords => new _Point.default(pointCoords));
    this.coordinates = this.points.map(point => point.coordinates);
  }
  toArray() {
    let reversed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this.points.map(point => point.toArray(reversed));
  }
  bounds() {
    const bounds = {
      north: null,
      south: null,
      west: null,
      east: null
    };
    this.coordinates.forEach(coord => {
      if ((0, _utils.isset)(coord.lat) && (0, _utils.isset)(coord.lon)) {
        bounds.north = Math.max(bounds.north, coord.lat);
        bounds.south = Math.min(bounds.south, coord.lat);
        bounds.west = Math.min(bounds.west, coord.lon);
        bounds.east = Math.max(bounds.east, coord.lon);
      }
    });
    return _CoordinateBounds.default.fromBounds(bounds);
  }
}
var _default = exports.default = MultiPoint;
module.exports = exports.default;